export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    loading: '加载中...',
    success: '操作成功',
    error: '操作失败',
    networkError: '网络错误'
  },
  nav: {
    home: '首页',
    card: '名片',
    contacts: '联系人',
    chat: '聊天',
    profile: '个人中心'
  },
  profile: {
    title: '个人中心',
    personalInfo: '个人信息',
    editProfile: '编辑资料',
    myCards: '我的名片',
    myContacts: '我的联系人',
    settings: '设置',
    logout: '退出登录',
    totalVisitors: '总访客数',
    friendCount: '好友数',
    todayVisitors: '今日访客',
    todayIncrement: '今日增长'
  },
  settings: {
    accountSecurity: '账户安全',
    notificationSettings: '通知设置',
    languageSettings: '语言设置',
    logout: '退出登录',
    accountSecurityDesc: '修改密码、绑定手机等',
    notificationSettingsDesc: '管理消息通知偏好',
    languageSettingsDesc: '选择应用语言',
    logoutDesc: '安全退出当前账户'
  },
  language: {
    title: '语言设置',
    selectLanguage: '选择语言',
    zhCN: '中文（简体）',
    enUS: '英语',
    jaJP: '日语',
    koKR: '韩语',
    ruRU: '俄语'
  },
  contact: {
    sameLevel: '同级别联系人',
    higherLevel: '上级联系人',
    goldMember: '黄金会员',
    platinumMember: '铂金会员',
    diamondMember: '钻石会员',
    unlock: '解锁',
    contact: '联系',
    unlockContact: '解锁联系人',
    upgradeForContacts: '升级会员解锁更多联系人'
  },
  storage: {
    basicPlan: '基础版',
    professionalPlan: '专业版',
    enterprisePlan: '企业版',
    month: '月',
    features: {
      basic: ['50GB存储空间', '基础安全保护', '文件分享'],
      professional: ['200GB存储空间', '高级安全加密', '团队协作', '优先客服'],
      enterprise: ['1TB存储空间', '企业级安全', '无限协作', '专属客服']
    },
    buyStorage: '购买存储空间',
    buyPlan: '购买套餐',
    uploadFile: '上传文件',
    viewFiles: '查看文件',
    downloadAll: '批量下载',
    documents: '文档',
    images: '图片',
    videos: '视频',
    others: '其他'
  },
  menu: {
    myCards: '我的名片',
    myCardsDesc: '管理我的数字名片',
    memberCenter: '会员中心',
    memberCenterDesc: '升级会员享更多权益',
    myFavorites: '我的收藏',
    myFavoritesDesc: '查看收藏的内容',
    myRelations: '我的关系',
    myRelationsDesc: '管理社交关系',
    chat: '聊天交友',
    chatDesc: '与好友聊天互动',
    contacts: '通讯录',
    contactsDesc: '管理联系人',
    privacy: '隐私设置',
    privacyDesc: '管理隐私权限'
  }
}
